module.exports = __webpack_public_path__ + "static/img/download.2d137c60.png";